export enum CoreTableClassEnum {
  STRIPED = 'striped',
  WELL = 'well',
  FIXED_HEIGHT = 'fixed-height',
  INLINE = 'inline',
  CALENDAR = 'calendar',
  COMPACT = 'compact',
}
